import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';

function DonorPartnerDetail() {
  const { id } = useParams();
  const [partner, setPartner] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartner();
  }, [id]);

  const fetchPartner = async () => {
    try {
      const response = await axios.get(`/api/donors-partners/${id}`);
      setPartner(response.data);
    } catch (error) {
      console.error('Error fetching partner:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container py-5">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  if (!partner) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">
          <h4>Partner Not Found</h4>
          <p>The donor/partner you are looking for does not exist.</p>
          <Link to="/" className="btn btn-primary">Go Home</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <nav aria-label="breadcrumb" className="mb-4">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/" className="text-decoration-none" style={{ color: 'var(--tgh-blue-light)' }}>
              Home
            </Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {partner.name}
          </li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-lg-4 text-center mb-4 mb-lg-0">
          {partner.image && (
            <img
              src={partner.image}
              alt={partner.name}
              className="img-fluid"
              style={{ maxWidth: '300px', width: '100%', objectFit: 'contain' }}
              onError={(e) => {
                e.target.src = '/img/Insurance.jpeg';
              }}
            />
          )}
        </div>
        <div className="col-lg-8">
          <h1 className="mb-3" style={{ color: 'var(--tgh-blue)', fontSize: '2.5rem' }}>
            {partner.name}
          </h1>
          
          {partner.description && (
            <div className="mb-4">
              <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333' }}>
                {partner.description}
              </p>
            </div>
          )}

          {partner.website && (
            <div className="mt-4">
              <a
                href={partner.website}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary btn-lg"
              >
                Visit Website <i className="bi bi-box-arrow-up-right ms-2"></i>
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DonorPartnerDetail;
